<template>
  <div class="login-enter-code">
    <cookies-disabled-error v-if="cookiesDisabledError" class="error-holder" />
    <login-member-doesnt-exist-error v-else-if="memberDoesntExist" :phoneNumber="phoneNumber" />

    <div v-else>
      <img class="image-container" :src="require('@/assets/hero-login.svg')">
      <div class="content">
        <enter-code :phone-number="phoneNumber"
                    :confirm-code-action="authenticateAndProceed"
                    :regenerate-code-action="forceGenerateCode"
                    :server-error="serverErrors.authenticate"
                    :button-title="'להמשיך'"
                    :loading="loading"
                    :reset-error="() => resetError('authenticate')"/>
      </div>
    </div>
    <login-support-footer-positioned />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import LoginMemberDoesntExistError from '@/pages/responsive-pages/non-authenticated/login/LoginMemberDoesntExistError';
import router from '@/router';

import LoginSupportFooterPositioned from '@/base-components/LoginSupportFooterPositioned';
import utils from '../../../../utils/phoneNumber';

import EnterCode from '../../../../base-components/EnterCode.vue';
import Segment from '../../../../Segment';
import CookiesDisabledError from '../../../general-errors/CookiesDisabledError.vue';

export default {
  name: 'LoginEnterCode',
  components: {
    LoginSupportFooterPositioned,
    EnterCode,
    CookiesDisabledError,
    LoginMemberDoesntExistError,
  },
  data() {
    return {
      redirectTo: '',
      loading: false,
      memberDoesntExist: false,
    };
  },
  created() {
    this.redirectTo = this.$route.query.redirectTo || 'sr';
    if (!this.phoneNumber) {
      if (this.$route.query.phoneNumber) {
        this.setPhoneNumber(utils.formatPhoneNumber(this.$route.query.phoneNumber));
      } else {
        this.redirectToLogin();
      }
    }
    Segment.trackUserGot('LoginEnterCodeEntered');
  },
  computed: {
    ...mapState('login', ['phoneNumber', 'serverErrors']),
    ...mapGetters('login', ['errorTypes']),
    cookiesDisabledError() {
      return this.serverErrors.authenticate === this.errorTypes.cookiesDisabled;
    },
  },
  methods: {
    ...mapMutations('login', ['resetError', 'setPhoneNumber']),
    ...mapActions('session', ['initRiseupAccount']),
    ...mapActions('login', ['authenticate', 'forceGenerateCode']),
    redirectToOldState() {
      const carryParams = _.omit(this.$route.query, ['redirectTo', 'phoneNumber']);
      router.push({ path: `/${this.redirectTo}`, query: carryParams });
    },
    redirectToLogin() {
      router.push({ path: '/login', query: this.$route.query });
    },
    redirectToWineAndDine() {
      router.push({ path: '/signup/lq/question/financialControl', query: this.$route.query });
    },
    async authenticateAndProceed(code) {
      Segment.trackUserInteraction('LoginCodeEnteredClicked');
      try {
        this.loading = true;
        const { customerId, riseupAccountId } = await this.authenticate(code);
        if (customerId) {
          this.redirectToOldState();
        } else if (riseupAccountId) {
          await this.initRiseupAccount(this.phoneNumber);
          // We already have a riseup account but not for cashflow
          // so we send the user to wine and dine flow.
          await this.redirectToWineAndDine();
        } else {
          this.memberDoesntExist = true;
        }
      } catch (e) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .error-holder {
    margin: 30px;
  }

  .login-enter-code {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    .image-container {
      width: 100%;
    }

    .content {
      margin: 30px;
    }
  }
</style>
